import { StyledButton } from '../../Atoms/Button/styles'
import { StyledSVG } from '../../Atoms/SVG/styles'
import { fadeIn, scaleUp } from '../../Styles/keyframes'
import { createAnimation, styled } from '../../Styles/stitches.config'

export const StyledCarouselItem = styled('div', {
    [`& ${StyledButton}`]: {
        alignContent: 'center',
        display: 'grid',
        position: 'relative',
        w: '100%',

        '&:disabled': {
            bc: '$primary400',
            bgc: 'rgba(255, 255, 255, 0)',
            color: '$primary400',
        },

        '@mobile': {
            h: '70px !important',
            gap: 4,
        },

        '@desktop': {
            h: '80px !important',
            gap: 8,
        },

        [`& ${StyledSVG}`]: {
            ...createAnimation([scaleUp, fadeIn]),
            color: '$primary400',
            position: 'absolute',
            right: 2,
            top: 2,

            '@mobile': {
                size: 12,
            },
        },
    },
})
